// src/components/publications/Publications.jsx
import groupedByYear from "./useBibtexData";
import PublicationPage from "./PublicationPage";
import { publicationType, publicationTypes } from "./publicationTypes";

const formatLabel = (entry, isPortuguese) => {
  const format = publicationTypes.find(([key]) => key === publicationType(entry));
  return format ? (isPortuguese ? format[1] : format[2]) : null;
};

export default function Publications() {
  return (
    <PublicationPage
      groupedByYear={groupedByYear}
      title="Publications"
      filterFn={() => true}
      basePath="publications"
      showReference={true}
      formatLabel={formatLabel}
    />
  );
}
